<template>
  <div :class="$style.wrap">
    <base-form
      :currentIndex="active"
      :key="active"
      @giveData="giveData"
      ref="form"
      :has-captcha="list.hasCaptcha"
      :items="data"
      :label-width="list.labelWidth"
      :submit-text="list.submitText"
      @submit="onSubmit"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { verifyPhoneBind, checkCode } from "@/http/user";
import { modifypassword } from "@/http/account";
import { mixinForward } from "@/mixins/mixinForward";
import { minxinActive } from "@/mixins/minxinActive";
import BaseForm from "@/components/BaseForm";
const CHECK_TYPE = 4; //找回密码
export default {
  name: "findPassword",
  components: { BaseForm },
  mixins: [minxinActive, mixinForward],
  data() {
    return {
      loginCode: this.$ls.get("loginCode" || ""),
      passwordList: {
        "0": {
          submitText: "下一步",
          labelWidth: "4em",
          hasCaptcha: "other"
        },
        "1": {
          submitText: "下一步",
          labelWidth: "6em",
          hasCaptcha: "send"
        },
        "2": {
          submitText: "确定",
          labelWidth: "4em",
          hasCaptcha: false
        }
      },
      dataList: this.$ls.get("dataList") || [
        { title: "第一步", filed: [{ name: "userAccount" }] },
        {
          title: "第二步",
          filed: [
            { name: "boundiconPhone", disabled: true },
            { name: "telCode", type: CHECK_TYPE }
          ]
        },
        {
          title: "第三步",
          filed: [{ name: "newPassword" }]
        }
      ]
    };
  },
  computed: {
    list() {
      return this.passwordList[this.active];
    },
    data() {
      return this.dataList[this.active].filed;
    }
  },
  mounted() {
    this.SetLeave(false);
  },
  methods: {
    ...mapActions(["SetLeave"]),
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 验证
     */
    onSubmit(formdata, validate, callback) {
      let listEvent = {
        "0": () => {
          this.verifyPhoneBind(formdata, validate, callback);
        },
        "1": () => {
          this.checkCode(formdata);
        },
        "2": () => {
          this.setNewPassword(formdata);
        }
      };
      listEvent[this.active]();
    },
    /**
     * @description 设置新的密码
     * @param {object} formdata  - 表单对象值
     */
    async setNewPassword(formdata) {
      let { newPassword } = formdata;
      const parmas = {
        new_password: newPassword,
        s_login_code: this.loginCode,
        type: 2
      };
      modifypassword(parmas)
        .then(res => {
          if (res.rcode == 0) {
            this.success("密码重置成功", {
              countdown: true,
              callback: () => {
                this.removeAll();
                this.$refs.form.disabled = false;
                this.SetLeave(true);
                if (this.forward) {
                  location.href = this.forward;
                } else {
                  this.$router.replace({
                    path: this._anchor.login.path,
                    query: {
                      account: this.resetFieldValue(0, "userAccount")
                    }
                  });
                }
              }
            });
          } else if (res.rcode == 6002) {
            this.backFirstStep();
          }
        })
        .catch(() => {
          this.$refs.form.disabled = false;
        })
        .finally(() => {
          this.$refs.form.disabled = false;
        });
    },
    /**
     * @description 回到第一步
     */
    backFirstStep() {
      //清空第三步填的新密码
      this.resetFieldValue(2, "newPassword");
      //清空第二步填的验证码
      this.resetFieldValue(1, "telCode");
      //返回第一步
      this.active = 0;
      this.$ls.set("active", this.active);
    },
    /**
     * @description  检验验证码
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 验证
     */
    async checkCode(formdata, validate) {
      let { telCode } = formdata;
      let parmas = Object.assign(
        {},
        {
          code: telCode,
          s_login_code: this.loginCode,
          type: 4
        },
        validate || {}
      );
      checkCode(parmas)
        .then(res => {
          if (res.rcode == 0) {
            this.setActive();
          } else if (res.rcode == 6002) {
            this.backFirstStep();
          }
        })
        .catch(() => {
          this.$refs.form.disabled = false;
        })
        .finally(() => {
          this.$refs.form.disabled = false;
        });
    },
    /**
     * @description  验证账号是否存在/是否绑定
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 验证
     */
    async verifyPhoneBind(formdata, validate, callback) {
      let { userAccount } = formdata;

      let parmas = Object.assign(
        {},
        {
          login_code: userAccount
        },
        validate || {}
      );
      verifyPhoneBind(parmas)
        .then(res => {
          if (callback) callback(res.rcode);
          if (res.rcode == 0) {
            this.setActive();
            let {
              data: { s_login_code, phone }
            } = res;
            this.loginCode = s_login_code;
            this.$ls.set("loginCode", this.loginCode);
            //设置第二步的加密电话
            this.setFieldValue(1, "boundiconPhone", phone);
            this.$refs.form.disabled = false;
          } else if (res.rcode == 5003) {
            this.$Dialog
              .confirm({
                message: "账号未绑定手机，可通过账号申诉找回密码",
                confirmButtonText: "马上去申诉"
              })
              .then(() => {
                this.SetLeave(true);
                this.$router.replace({
                  path: this._anchor.appealSubmit.path,
                  query: { account: userAccount }
                });
              })
              .catch(() => {
                this.$refs.form.disabled = false;
              });
          }
        })
        .catch(() => {})
        .finally(() => {
          this.resetVaildator();
        });
    },
    /**
     * @description  重置极致验证状态
     */
    resetVaildator() {
      if (this.$refs.form.validator) {
        this.$refs.form.validator.reset();
      }
      this.$refs.form.disabled = false;
    },
    /**
     * @description 页面步骤回退
     */
    goBack() {
      if (this.active === 2) {
        this.$Toast({
          message: "返回上一步需重新验证手机",
          onClose: () => {
            //清空第三步填的新密码
            this.resetFieldValue(2, "newPassword");
            //清空第二步填的验证码
            this.resetFieldValue(1, "telCode");
            this.backActive();
          }
        });
        return false;
      } else if (this.active === 1) {
        //清空第二步填的验证码
        this.resetFieldValue(1, "telCode");
        this.backActive();
        return false;
      }
      return true;
    },
    /**
     * @description 移除存储数据
     */
    removeAll() {
      this.$ls.set("show", 0);
      this.$ls.remove("loginCode");
      this.$ls.remove("active");
      this.$ls.remove("active");
      this.$ls.remove("dataList");
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  padding-top: 1.68rem;
}
</style>
